// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --ion-padding: 12px;
}

ion-header {
  background: var(--ion-color-primary);
}

ion-item {
  position: relative;
  max-height: 42px;
  border: 0.8px solid rgba(197, 197, 197, 0.4784313725);
  border-radius: var(--radius-default);
  --background: transparent !important;
  overflow: visible;
}
ion-item.input-error {
  border: 0.8px solid #cc0e0e;
}
ion-item ion-input {
  font-family: AppFontMedium, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 127%;
  --padding-start: 14px;
  color: #1e1e1c;
}
ion-item:not(:has(ion-checkbox)) {
  display: flex;
  align-items: center;
}
ion-item:has(ion-checkbox) {
  border: none;
}
ion-item .input-error {
  border: 0.8px solid #cc0e0e;
}

.checkbox-item {
  display: flex;
  align-items: flex-start;
}
.checkbox-item ion-checkbox {
  --checkmark-color: #fff;
}

.din-pro-cond-med {
  margin-inline-start: 0;
  padding-top: 2px;
  font-family: AppFontMedium;
  font-size: 10px;
  line-height: 16.9px;
  text-align: left;
  color: var(--color-black);
}
.din-pro-cond-med a {
  color: var(--color-text-green);
  text-decoration: underline;
}

.underline {
  color: inherit;
  position: relative;
  z-index: 10;
  color: var(--color-text-green);
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

ion-slide {
  width: 100% !important;
}
ion-slide > ion-col {
  overflow: auto;
  top: 0;
  bottom: 0;
  position: absolute;
  text-align: left;
}

.phone-item {
  border: none;
}
.phone-item ion-input:first-child {
  margin-right: 10px;
}
.phone-item ion-input {
  margin-bottom: 5px;
}

ion-card {
  margin: 0;
  margin-bottom: 10px;
  border-radius: var(--radius-default);
  text-align: initial;
  color: var(--color-black);
  overflow: auto;
  box-shadow: none;
  background: transparent;
  box-sizing: border-box;
}

.info-row:not(:last-child) {
  margin-bottom: 9px;
}

.left-col {
  padding: 0;
  padding-right: 5px;
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 127%;
  font-weight: 400;
  color: #1e1e1c;
}

.right-col {
  padding: 0;
  font-family: AppFontMedium;
  font-size: 11px;
  line-height: 13.37px;
  text-align: right;
  color: var(--color-black);
}

.tip-text,
.tip-sum {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
}

.tip-sum {
  text-align: right;
}

.item-row {
  margin-bottom: 10px;
}

.arcticle-name-col,
.article-price-col {
  padding: 0;
  margin-bottom: 5px;
  font-family: AppFont;
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  color: #1e1e1c;
}

.article-price-col,
.option-price {
  font-family: AppFont;
  text-align: right !important;
}

.option-name,
.option-price {
  font-family: AppFont;
  font-size: 11px;
  line-height: 15px;
  text-align: left;
}

.price-title,
.price-sum {
  margin: 0;
  font-family: AppFontBold;
  font-size: 18px;
  line-height: 120%;
  color: var(--color-black);
  letter-spacing: 0.02em;
  text-transform: capitalize;
}

.price-sum {
  font-family: AppFontBold;
  text-align: end;
}

ion-card-header {
  border-bottom: var(--outline-default);
  border-top: var(--outline-default);
  padding: 14px 0;
  margin: 0 auto;
}
ion-card-header ion-button {
  --background: #f0f7f8;
  --color: black;
  border: 1.5px solid #f0f7f8;
  text-transform: none;
  height: 30px;
  width: 30px;
  --border-radius: 50%;
  box-shadow: none;
  border: none;
  --box-shadow: none;
}

ion-card-content {
  padding: 12px 0;
  margin: 0 auto;
}
.border-top-light-blue {
  border-top: 0.5px solid #e5e5e5;
}

ion-card-title {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.02em;
  text-align: left;
  text-transform: uppercase;
  color: var(--color-black);
}

ion-chip {
  margin: 0;
  padding: 0 6px;
  margin-left: auto;
  width: -moz-fit-content;
  width: fit-content;
  min-width: 36px;
  height: 26px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #785526;
  border-radius: var(--radius-default);
}
ion-chip ion-label {
  font-family: AppFontSemiBold;
  font-size: 14px;
  line-height: 16.2px;
  text-align: center;
  color: #fff;
}

.card-content-md {
  font-weight: unset;
}

.adds-price {
  padding-left: 5px;
  font-family: AppFont;
  font-size: 11px;
}

.phone-block {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.phone-block ion-select {
  padding-bottom: 0;
  background: white;
  overflow: hidden;
  color: var(--ion-color-main);
  font-weight: 700;
  height: 68px;
  text-align: center;
  padding-top: 0;
  border-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
.phone-block ion-input {
  width: 70%;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}

.edit {
  display: flex;
  justify-content: flex-end;
}

ion-footer {
  padding: 12px 16px;
  background: linear-gradient(176.99deg, rgba(255, 255, 255, 0.45) -165.76%, rgba(255, 255, 255, 0.45) 97.51%) !important;
  box-shadow: 2px 0px 5px 0px rgba(0, 0, 0, 0.2509803922);
}

.padding {
  padding: 22px;
}

.icon-edit {
  height: 30px;
  width: 30px;
}

.privacy-content {
  padding: 13px 12px 14px;
}

.privacy {
  margin: 12px 0 0;
  font-family: AppFont;
  font-size: 12px;
  line-height: 16.55px;
  text-align: center;
  color: #1e1e1c;
}

.order-at-header {
  font-family: Capture;
  font-weight: normal;
  margin-top: 25px;
  color: var(--ion-color-secondary);
}

ion-checkbox {
  margin-left: 3px;
}

ion-checkbox {
  --background: transparent;
  --background-checked: var(--ion-color-primary);
  --border-color: var(--ion-color-primary-shade);
  --border-color-checked: var(--ion-color-primary);
  --checkbox-background-checked: var(--ion-color-primary);
  --border-width: 1px;
  --checkmark-color: var(--color-white);
  --checkmark-width: 2px;
  --border-radius: var(--radius-default);
  --checkbox-background: transparent;
  --size: 20px;
}

.sec-main-col {
  padding: 20px 16px;
}

.btn {
  width: 100%;
  height: 54px;
  outline: none;
  background: var(--ion-color-tertiary);
  border-radius: 1px;
  border: 1px solid var(--ion-color-secondary);
  box-shadow: 2px 2px 0 #000000;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (min-width: 991px) {
  .btn {
    height: 67px;
  }
}
.btn span {
  font-family: AppFont;
  color: var(--ion-color-secondary);
  font-size: 18px;
  font-weight: 400;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}

.miles {
  border-top: 0.5px solid #311802;
  border-bottom: 0.5px solid #311802;
  margin: 12px 0;
  padding-inline: 12px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
}
.miles__img {
  width: 100px;
  height: 17px;
}
.miles__info {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.miles__info span {
  font-family: AppFontBoldAlt;
  font-size: 12px;
  line-height: 14.4px;
  color: #226086;
  width: 64%;
}
.miles__info.applied {
  width: 120px;
}
.miles__info.applied span {
  width: 100%;
}
.miles__icon {
  height: 20px;
  width: 20px;
}
.miles__icon.applied {
  height: 20px;
  width: 20px;
  flex-grow: 1;
}

.relative-block {
  position: relative;
}

.input-col {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.input-col:has([name=email]) {
  margin-bottom: 25px;
}
.input-col ion-label {
  max-width: 50%;
  font-family: AppFont;
  font-size: 14px;
  line-height: 127%;
  letter-spacing: 0.01em;
  text-transform: capitalize;
  color: var(--ion-color-black);
}
.input-col ion-item {
  width: 57%;
}

.table-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 26px;
  min-width: 40px;
  padding-inline: 6px;
  background-color: var(--ion-color-primary);
  border: 1px solid var(--ion-color-primary);
  border-radius: 3px;
  cursor: pointer;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--color-white);
}
.table-chip ion-icon {
  --icon-color: var(--ion-color-primary-contrast);
  width: 10px;
}

.info-card-content {
  width: 100%;
  padding-block: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-card-content ion-icon {
  height: 22px;
  width: 32px;
}
.info-card-content p {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 91%;
  padding-inline: 10px;
  margin: 0;
  font-family: AppFontMedium;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 2%;
  text-align: start;
}

.info {
  background: #666666;
  color: #fff;
  padding: 7px;
}
.info .info-icon-col {
  display: flex;
}
.info .info-icon-col ion-icon {
  width: 18px;
  height: 18px;
}
.info p {
  font-family: AppFont;
  color: #fff;
  font-size: 9px;
  margin: 0;
}

.order-summary-card {
  border-bottom: var(--outline-default);
}

.error-text-block {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  transform: translate(0px, -10%);
}
.error-text-block.phone {
  bottom: -15px;
}
.error-text-block.agb {
  bottom: -10px;
}
.error-text-block .error-text {
  color: #bd3636;
  font-family: AppFont;
  font-weight: 400;
  font-size: 8px;
  line-height: 127%;
}

.privacy-checkbox {
  overflow: hidden;
}

.ion-spinner {
  color: white;
}

.updated-price {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,qDAAA;EACA,oCAAA;EACA,oCAAA;EACA,iBAAA;AADF;AAEE;EACE,2BAAA;AAAJ;AAGE;EACE,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;AAFJ;AAKE;EACE,YAAA;AAHJ;AAKE;EACE,2BAAA;AAHJ;;AAOA;EACE,aAAA;EACA,uBAAA;AAJF;AAME;EAEE,uBAAA;AALJ;;AASA;EACE,sBAAA;EACA,gBAAA;EAEA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAPF;AASE;EACE,8BAAA;EACA,0BAAA;AAPJ;;AAWA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;AARF;;AAWA;EACE,sBAAA;EACA,uBAAA;AARF;;AAWA;EACE,sBAAA;AARF;AASE;EACE,cAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,YAAA;AARF;AASE;EACE,kBAAA;AAPJ;AASE;EACE,kBAAA;AAPJ;;AAWA;EACE,SAAA;EACA,mBAAA;EAGA,oCAAA;EAEA,mBAAA;EACA,yBAAA;EACA,cAAA;EAEA,gBAAA;EACA,uBAAA;EACA,sBAAA;AAZF;;AAgBE;EACE,kBAAA;AAbJ;;AAiBA;EACE,UAAA;EACA,kBAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,UAAA;EAEA,0BAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;EAEA,yBAAA;AAjBF;;AAoBA;;EAEE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;;AAoBA;EACE,mBAAA;AAjBF;;AAoBA;;EAEE,UAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAlBF;;AAqBA;;EAEE,oBAAA;EACA,4BAAA;AAlBF;;AAqBA;;EAEE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAlBF;;AAsBA;;EAEE,SAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;AAnBF;;AAsBA;EACE,wBAAA;EACA,eAAA;AAnBF;;AAsBA;EAEE,qCAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;AApBF;AAsBE;EACE,qBAAA;EACA,cAAA;EACA,2BAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AApBJ;;AAwBA;EACE,eAAA;EACA,cAAA;AArBF;AA4BA;EACE,+BAAA;AA1BF;;AA6BA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EAEA,yBAAA;AA3BF;;AA8BA;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,oCAAA;AA5BF;AA6BE;EACE,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AA3BJ;;AA+BA;EACE,kBAAA;AA5BF;;AA+BA;EACE,iBAAA;EAEA,oBAAA;EACA,eAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA7BF;AA8BE;EACE,iBAAA;EAEA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,2BAAA;AA7BJ;AA+BE;EACE,UAAA;EACA,8BAAA;EACA,2BAAA;AA7BJ;;AAiCA;EACE,aAAA;EACA,yBAAA;AA9BF;;AAgCA;EACE,kBAAA;EACA,uHAAA;EAKA,uDAAA;AAjCF;;AAuCA;EACE,aAAA;AApCF;;AAsCA;EACE,YAAA;EACA,WAAA;AAnCF;;AAsCA;EACE,uBAAA;AAnCF;;AAsCA;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;AAnCF;;AAsCA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AAnCF;;AAsCA;EACE,gBAAA;AAnCF;;AAsCA;EACE,yBAAA;EACA,8CAAA;EACA,8CAAA;EACA,gDAAA;EACA,uDAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;EACA,sCAAA;EACA,kCAAA;EACA,YAAA;AAnCF;;AAsCA;EACE,kBAAA;AAnCF;;AAsCA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,4CAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnCF;AC9VE;EDuXF;IAaI,YAAA;EAlCF;AACF;AAoCE;EACE,oBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAlCJ;;AAsCA;EACE,+BAAA;EACA,kCAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAnCF;AAqCE;EACE,YAAA;EACA,YAAA;AAnCJ;AAqCE;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnCJ;AAoCI;EACE,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;AAlCN;AAqCE;EACE,YAAA;AAnCJ;AAqCI;EACE,WAAA;AAnCN;AAuCE;EACE,YAAA;EACA,WAAA;AArCJ;AAwCE;EACE,YAAA;EACA,WAAA;EACA,YAAA;AAtCJ;;AA0CA;EACE,kBAAA;AAvCF;;AA0CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAvCF;AAyCE;EACE,mBAAA;AAvCJ;AA0CE;EACE,cAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,6BAAA;AA1CJ;AA6CE;EACE,UAAA;AA3CJ;;AA+CA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;EACA,eAAA;EACA,mBAAA;EAEA,0CAAA;EACA,0CAAA;EACA,kBAAA;EAEA,eAAA;EAEA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AAhDF;AAkDE;EACE,+CAAA;EACA,WAAA;AAhDJ;;AAoDA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAjDF;AAmDE;EACE,YAAA;EACA,WAAA;AAjDJ;AAoDE;EACE,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,oBAAA;EAEA,SAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAnDJ;;AAsDA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAnDF;AAoDE;EACE,aAAA;AAlDJ;AAmDI;EACE,WAAA;EACA,YAAA;AAjDN;AAoDE;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;AAlDJ;;AAqDA;EACE,qCAAA;AAlDF;;AAoDA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;AAjDF;AAmDE;EACE,aAAA;AAjDJ;AAmDE;EACE,aAAA;AAjDJ;AAmDE;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAjDJ;;AAqDA;EACE,gBAAA;AAlDF;;AAqDA;EACE,YAAA;AAlDF;;AAqDA;EACC,gBAAA;AAlDD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n:root {\n  --ion-padding: 12px;\n}\n\nion-header {\n  background: var(--ion-color-primary);\n}\n\nion-item {\n  position: relative;\n  max-height: 42px;\n  border: 0.8px solid #c5c5c57a;\n  border-radius: var(--radius-default);\n  --background: transparent !important;\n  overflow: visible;\n  &.input-error {\n    border: 0.8px solid #cc0e0e;\n  }\n\n  ion-input {\n    font-family: AppFontMedium, sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 127%;\n    --padding-start: 14px;\n    color: #1e1e1c;\n  }\n\n  &:not(:has(ion-checkbox)) {\n    display: flex;\n    align-items: center;\n  }\n\n  &:has(ion-checkbox) {\n    border: none;\n  }\n  .input-error {\n    border: 0.8px solid #cc0e0e;\n  }\n}\n\n.checkbox-item {\n  display: flex;\n  align-items: flex-start;\n\n  ion-checkbox {\n    // margin-top: -3px;\n    --checkmark-color: #fff;\n  }\n}\n\n.din-pro-cond-med {\n  margin-inline-start: 0;\n  padding-top: 2px;\n\n  font-family: AppFontMedium;\n  font-size: 10px;\n  line-height: 16.9px;\n  text-align: left;\n  color: var(--color-black);\n\n  a {\n    color: var(--color-text-green);\n    text-decoration: underline;\n  }\n}\n\n.underline {\n  color: inherit;\n  position: relative;\n  z-index: 10;\n  color: var(--color-text-green);\n}\n\nion-slides {\n  width: 100% !important;\n  height: 100% !important;\n}\n\nion-slide {\n  width: 100% !important;\n  > ion-col {\n    overflow: auto;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n    text-align: left;\n  }\n}\n\n.phone-item {\n  border: none;\n  ion-input:first-child {\n    margin-right: 10px;\n  }\n  ion-input {\n    margin-bottom: 5px;\n  }\n}\n\nion-card {\n  margin: 0;\n  margin-bottom: 10px;\n\n  // border: 0.6px solid #9caeb9;\n  border-radius: var(--radius-default);\n\n  text-align: initial;\n  color: var(--color-black);\n  overflow: auto;\n  // box-shadow: 0px 0px 15px 0px #7d5d281a;\n  box-shadow: none;\n  background: transparent;\n  box-sizing: border-box;\n}\n\n.info-row {\n  &:not(:last-child) {\n    margin-bottom: 9px;\n  }\n}\n\n.left-col {\n  padding: 0;\n  padding-right: 5px;\n\n  font-family: AppFontMedium;\n  font-size: 14px;\n  line-height: 127%;\n  font-weight: 400;\n  color: #1e1e1c;\n}\n\n.right-col {\n  padding: 0;\n\n  font-family: AppFontMedium;\n  font-size: 11px;\n  line-height: 13.37px;\n  text-align: right;\n\n  color: var(--color-black);\n}\n\n.tip-text,\n.tip-sum {\n  font-family: AppFontBold;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0.02em;\n}\n\n.tip-sum {\n  text-align: right;\n}\n\n.item-row {\n  margin-bottom: 10px;\n}\n\n.arcticle-name-col,\n.article-price-col {\n  padding: 0;\n  margin-bottom: 5px;\n\n  font-family: AppFont;\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #1e1e1c;\n}\n\n.article-price-col,\n.option-price {\n  font-family: AppFont;\n  text-align: right !important;\n}\n\n.option-name,\n.option-price {\n  font-family: AppFont;\n  font-size: 11px;\n  line-height: 15px;\n  text-align: left;\n  // text-transform: uppercase;\n}\n\n.price-title,\n.price-sum {\n  margin: 0;\n  font-family: AppFontBold;\n  font-size: 18px;\n  line-height: 120%;\n  color: var(--color-black);\n  letter-spacing: 0.02em;\n  text-transform: capitalize;\n}\n\n.price-sum {\n  font-family: AppFontBold;\n  text-align: end;\n}\n\nion-card-header {\n  // background: white;\n  border-bottom: var(--outline-default);\n  border-top: var(--outline-default);\n  padding: 14px 0;\n  margin: 0 auto;\n\n  ion-button {\n    --background: #f0f7f8;\n    --color: black;\n    border: 1.5px solid #f0f7f8;\n    text-transform: none;\n    height: 30px;\n    width: 30px;\n    --border-radius: 50%;\n    box-shadow: none;\n    border: none;\n    --box-shadow: none;\n  }\n}\n\nion-card-content {\n  padding: 12px 0;\n  margin: 0 auto;\n\n  &:not(:last-child) {\n    // border-bottom: 0.5px solid #a2834f;\n  }\n}\n\n.border-top-light-blue {\n  border-top: 0.5px solid #e5e5e5;\n}\n\nion-card-title {\n  font-family: AppFontBold;\n  font-size: 16px;\n  line-height: 120%;\n  letter-spacing: 0.02em;\n  text-align: left;\n  text-transform: uppercase;\n\n  color: var(--color-black);\n}\n\nion-chip {\n  margin: 0;\n  padding: 0 6px;\n  margin-left: auto;\n  width: fit-content;\n  min-width: 36px;\n  height: 26px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background: #785526;\n  border-radius: var(--radius-default);\n  ion-label {\n    font-family: AppFontSemiBold;\n    font-size: 14px;\n    line-height: 16.2px;\n    text-align: center;\n    color: #fff;\n  }\n}\n\n.card-content-md {\n  font-weight: unset;\n}\n\n.adds-price {\n  padding-left: 5px;\n\n  font-family: AppFont;\n  font-size: 11px;\n}\n\n.phone-block {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ion-select {\n    padding-bottom: 0;\n\n    background: white;\n    overflow: hidden;\n    color: var(--ion-color-main);\n    font-weight: 700;\n    height: 68px;\n    text-align: center;\n    padding-top: 0;\n    border-radius: 0px;\n    border-bottom-left-radius: 0px;\n    border-top-left-radius: 0px;\n  }\n  ion-input {\n    width: 70%;\n    border-bottom-left-radius: 0px;\n    border-top-left-radius: 0px;\n    // padding: 8px 0px 8px 0px !important;\n  }\n}\n.edit {\n  display: flex;\n  justify-content: flex-end;\n}\nion-footer {\n  padding: 12px 16px;\n  background: linear-gradient(\n                  176.99deg,\n                  rgba(255, 255, 255, 0.45) -165.76%,\n                  rgba(255, 255, 255, 0.45) 97.51%\n  ) !important;\n  box-shadow: 2px 0px 5px 0px #00000040;\n\n  // &:has(.tip-row) {\n  // \tbox-shadow: -5px 0px 56px 0px #00000017;\n  // }\n}\n.padding {\n  padding: 22px;\n}\n.icon-edit {\n  height: 30px;\n  width: 30px;\n}\n\n.privacy-content {\n  padding: 13px 12px 14px;\n}\n\n.privacy {\n  margin: 12px 0 0;\n  font-family: AppFont;\n  font-size: 12px;\n  line-height: 16.55px;\n  text-align: center;\n  color: #1e1e1c;\n}\n\n.order-at-header {\n  font-family: Capture;\n  font-weight: normal;\n  margin-top: 25px;\n  color: var(--ion-color-secondary);\n}\n\nion-checkbox {\n  margin-left: 3px;\n}\n\nion-checkbox {\n  --background: transparent;\n  --background-checked: var(--ion-color-primary);\n  --border-color: var(--ion-color-primary-shade);\n  --border-color-checked: var(--ion-color-primary);\n  --checkbox-background-checked: var(--ion-color-primary);\n  --border-width: 1px;\n  --checkmark-color: var(--color-white);\n  --checkmark-width: 2px;\n  --border-radius: var(--radius-default);\n  --checkbox-background: transparent;\n  --size: 20px;\n}\n\n.sec-main-col {\n  padding: 20px 16px;\n}\n\n.btn {\n  width: 100%;\n  height: 54px;\n  outline: none;\n  background: var(--ion-color-tertiary);\n  border-radius: 1px;\n  border: 1px solid var(--ion-color-secondary);\n  box-shadow: 2px 2px 0 #000000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @include desktop {\n    height: 67px;\n  }\n\n  span {\n    font-family: AppFont;\n    color: var(--ion-color-secondary);\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 19.2px;\n    letter-spacing: 0.01em;\n  }\n}\n\n.miles {\n  border-top: 0.5px solid #311802;\n  border-bottom: 0.5px solid #311802;\n  margin: 12px 0;\n  padding-inline: 12px;\n  background-color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  width: 100%;\n\n  &__img {\n    width: 100px;\n    height: 17px;\n  }\n  &__info {\n    flex-grow: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    span {\n      font-family: AppFontBoldAlt;\n      font-size: 12px;\n      line-height: 14.4px;\n      color: #226086;\n      width: 64%;\n    }\n  }\n  &__info.applied {\n    width: 120px;\n\n    span {\n      width: 100%;\n    }\n  }\n\n  &__icon {\n    height: 20px;\n    width: 20px;\n  }\n\n  &__icon.applied {\n    height: 20px;\n    width: 20px;\n    flex-grow: 1;\n  }\n}\n\n.relative-block {\n  position: relative;\n}\n\n.input-col {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n\n  &:has([name='email']) {\n    margin-bottom: 25px;\n  }\n\n  ion-label {\n    max-width: 50%;\n\n    font-family: AppFont;\n    font-size: 14px;\n    line-height: 127%;\n    letter-spacing: 0.01em;\n    text-transform: capitalize;\n\n    color: var(--ion-color-black);\n  }\n\n  ion-item {\n    width: 57%;\n  }\n}\n\n.table-chip {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n\n  height: 26px;\n  min-width: 40px;\n  padding-inline: 6px;\n\n  background-color: var(--ion-color-primary);\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 3px;\n\n  cursor: pointer;\n\n  font-family: AppFontBold;\n  font-size: 12px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  vertical-align: middle;\n  text-transform: capitalize;\n  color: var(--color-white);\n\n  ion-icon {\n    --icon-color: var(--ion-color-primary-contrast);\n    width: 10px;\n  }\n}\n\n.info-card-content {\n  width: 100%;\n  padding-block: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ion-icon {\n    height: 22px;\n    width: 32px;\n  }\n\n  p {\n    width: fit-content;\n    max-width: 91%;\n    padding-inline: 10px;\n\n    margin: 0;\n    font-family: AppFontMedium;\n    font-size: 12px;\n    line-height: 100%;\n    letter-spacing: 2%;\n    text-align: start;\n  }\n}\n.info {\n  background: #666666;\n  color: #fff;\n  padding: 7px;\n  .info-icon-col {\n    display: flex;\n    ion-icon {\n      width: 18px;\n      height: 18px;\n    }\n  }\n  p {\n    font-family: AppFont;\n    color: #fff;\n    font-size: 9px;\n    margin: 0;\n  }\n}\n.order-summary-card {\n  border-bottom: var(--outline-default);\n}\n.error-text-block {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  transform: translate(0px, -10%);\n\n  &.phone {\n    bottom: -15px;\n  }\n  &.agb {\n    bottom: -10px;\n  }\n  .error-text {\n    color: #bd3636;\n    font-family: AppFont;\n    font-weight: 400;\n    font-size: 8px;\n    line-height: 127%;\n  }\n}\n\n.privacy-checkbox {\n  overflow: hidden;\n}\n\n.ion-spinner {\n  color: white;\n}\n\n.updated-price {\n\tmargin-top: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
